import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import '@shoelace-style/shoelace/dist/components/dropdown/dropdown.js';
import { emit } from '@amityeko/pbc-core/dist/utilities/event';
import '../icon';
import '../typography/tg-body-two';
import styles from './styles';
/**
 * @dependency amityeko-icon
 * @dependency amityeko-tg-body-two
 *
 * @slot <default> - Trigger element.
 *
 * @event amityeko-select {{ value }} - Emitted when an item is selected.
 */
export default class AmityekoDropdown extends LitElement {
    constructor() {
        super(...arguments);
        this.placement = 'bottom-end';
        this.options = [];
    }
    _onSelect(e) {
        e.stopPropagation();
        emit(this, 'amityeko-select', { detail: { value: e.detail.item.value } });
    }
    render() {
        return html `
      <sl-dropdown
        class="dropdown"
        distance="4"
        hoist
        .placement=${this.placement}
        @sl-select=${this._onSelect}
      >
        <slot slot="trigger"></slot>
        <sl-menu class="menu">
          ${this.options.map((item) => html `
              <sl-menu-item
                class=${classMap({
            menu__item: true,
            'menu__item--with-icon': Boolean(item.iconSvg),
        })}
                style=${styleMap({
            '--private-color': typeof item.color === 'string' ? item.color : null,
        })}
                .value=${item.value}
              >
                ${item.iconSvg
            ? html `
                      <amityeko-icon slot="prefix" .iconSize=${'16px'}>
                        ${item.iconSvg}
                      </amityeko-icon>
                    `
            : null}
                <amityeko-tg-body-two class="menu__item__label">${item.label}</amityeko-tg-body-two>
              </sl-menu-item>
            `)}
        </sl-menu>
      </sl-dropdown>
    `;
    }
}
AmityekoDropdown.styles = styles;
__decorate([
    property()
], AmityekoDropdown.prototype, "placement", void 0);
__decorate([
    property({ type: Array })
], AmityekoDropdown.prototype, "options", void 0);
if (!customElements.get('amityeko-dropdown')) {
    customElements.define('amityeko-dropdown', AmityekoDropdown);
}
//# sourceMappingURL=index.js.map